import React from 'react'
import isEmpty from 'lodash/isEmpty'

const TTTable = (props) => {
    const { data, type, buttonText, notification, leftIndex, rightIndex, q } = props;

    if(type === 'customers'){
        return (
            <div>
            <table className="display_table">
                <thead>
                    <tr className="table-header">
                        <th>#</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Top Tier</th>
                    </tr>
                </thead>
                <tbody>
                    {!!data && data.length <= 0 && isEmpty(q) && <tr><td/><td colSpan="3">{notification}</td></tr>}
                    {!!data && data.length <= 0 && !isEmpty(q) && <tr><td/><td colSpan="3">{'No results found.'}</td></tr>}
                    {!!data && data.length > 0 &&
                    !!data && data.slice(leftIndex, rightIndex).map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.fname}</td>
                                <td>{item.lname}</td>
                                <td>{item.email}</td>
                                <td>{item.name ? item.name : ''}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
        ) 
    }
    else {
        return (
            <div>
                <table className="display_table">
                    <thead>
                        <tr className="table-header">
                            <th/>
                            <th>Title</th>
                            <th>Sku</th>
                            <th>Active</th>
                            <th/>
                        </tr>
                    </thead>
                    <tbody>
                        {!!data && data.length <= 0 && isEmpty(q) && <tr><td/><td colSpan="3">{notification}</td></tr>}
                        {!!data && data.length <= 0 && !isEmpty(q) && <tr><td/><td colSpan="3">{'No results found.'}</td></tr>}
                        {!!data && data.length > 0 &&
                        !!data && data.slice(leftIndex, rightIndex).map((item, i) => {
                            return (
                                <tr className="clickable" key={i} onClick={() => props.action(type, item.id)}>
                                    <td className="record-number">{leftIndex + i + 1}</td>
                                    <td data-id="Title">{item.title}</td>
                                    <td data-id="Sku">{item.sku}</td>
                                    <td data-id="Active">{item.active ? 'Yes' : 'No'}</td>
                                    <td className="edit-cell"><div className="edit_btn">{buttonText}</div></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default TTTable



// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/products/products-search/TTTable.js